<style>
@import "../../static/viewer/viewer.mini.css";
</style>
<template>
<Card :padding="0" :bordered="myConfig.bordered" :dis-hover="myConfig.disHover" :headClass="headClass" :extraClass="extraClass">
    <p v-if="showTitle" slot="title" :style="pStyle" @click="toggle" >
        <span :class="titleClass" v-text="myConfig.title" /> <Icon v-if="myConfig.hide" :style="iconStyle" type='ios-arrow-forward'/> 
    </p>
     <Upload v-show="false" id="iviewUp" 
        multiple
        ref="upload"
        :show-upload-list="false"
        :on-success="handleSuccess"
        :on-exceeded-size="handleMaxSize"
        :before-upload="handleBeforeUpload"
        :max-size="fileSize"
        :action="uploadfile">
        <a>上传</a>
    </Upload>
    <a  slot="extra" v-if="(showBtn || !myConfig.readOnly) && !btnReadOnly"  href="#" @click.prevent="editGrid">{{myConfig.editBtnName}} </a>
    <span  slot="extra" v-if="(showBtn || !myConfig.readOnly) && btnReadOnly" >{{myConfig.editBtnName}} </span>
    <a  slot="extra" v-if="showBtn && !myConfig.readOnly"  style="margin-left: 10px;"  href="#" @click.prevent="cancelGrid">{{myConfig.cancelBtnName}} </a>
    <div v-show="showGrid" :style="cardStyle" >
         <EditGrid ref="grid" :config="myConfig"></EditGrid>
    </div>
     <div ref="photo" v-show="false">
        <li><img  :src="imgUrl" style="width: 100%; height: 100%;" /></li>
    </div>
    <Modal :styles="{top:'20px', width:'80%'}"  title="文本"  v-model="txtPanelFlag"  :footer-hide="true">
        <div v-html="textStr"/>
    </Modal>
      <Modal :styles="{top:'20px', width:'80%'}"  title="PDF"  v-model="pdfFlag"  :footer-hide="true">
        <div ref="pdf" style="height:630px"/>
    </Modal>
</Card>
</template>
<script>
import load from '@/components/base/load';
import $ from 'jquery';
import Viewer from 'viewer';
import pdfObject from 'pdfobject';
export default {
    name: 'appendix',
    mixins: [load],
    data () {
        return {
            myConfig:{
                cancelBtnName:'放弃',
                editBtnName:'上传',
                hide:true,
                headStyle:'',
                titleType:1,
                bordered:true,   
                disHover:false,
                readOnly: false,
                downfile:'/mall-fileservice/downloadFile?data=',
                delfile:'/mall-fileservice/deleteFile?data=',
                uploadfile:'/mall-fileservice/uploadFile',
                pdffile:'/mall-fileservice/previewFile?data=',
                notdelfile:false,
                delDbFile:false,
                fileSize:20,
                fileNum:10,
                title:'附件',
                dynamicHeight:true,
                height:840,
                items:[{
                    label:'操作状态',
                    name:'modflag',
                    type:'ComboBox',
                    data:[{  code : 'N',  name : '初始'}, {  code : 'M',  name : '待删除'},
                        {  code : 'I',  name : '新增'}, {  code : 'D',  name : '删除'}],
                    visible:false,
                    width:100,
                },{
                    label:'文件名称',
                    name:'filename',
                    type:'TextBox',
                    readOnly:true
                },{
                    label:'文件大小',
                    name:'filesize',
                    render: this.sizeActionRender,
                    width:120,
                    readOnly:false
                },{
                    label:'上传日期',
                    name:'ph_timestamp',
                    type:'DateBox',
                    vtype:'datetime',
                    width:200,
                    readOnly:true
                },{
                    label:'操作',
                    key:'action',
                    render: this.actionRender
                }]
            },
            headers:{
            },
            cardPadding:0,
            cardStyle:'',
            showGrid:true,
            showTitle:true,
            showBtn:false,
            pStyle:'',
            iconStyle:'',
            uploadfile:'',
            textStr:'',
            imgUrl:'',
            txtPanelFlag:false,
            pdfFlag:false,
            btnReadOnly:false,
            fileSize:0,
            initData:[]
        };
    },
    created() {
        this.myConfig = Object.assign({},this.myConfig, this.config);
        this.myConfig.tableSize = 'small';
        this.myConfig.showBorder = false;
        this.myConfig.showAddBtn = false;
        this.myConfig.showDelBatchBtn = false;
        // 处理模块号提示
        let modulecode = this.$Method.getUrlParam('modulecode');
        if (!modulecode) {
            modulecode = this.$Method.getUrlParam('billmoduleid');
        }
        if (this.modulecode) {
            modulecode = this.modulecode;
        }
        if (this.myConfig.fileSize !== undefined) {
            this.fileSize = Number(this.myConfig.fileSize) * 1024;
        }
        if (this.myConfig.showBtn !== undefined) {
            this.showBtn = this.myConfig.showBtn;
        }
        this.myConfig.modulecode = modulecode;
        this.headers.billmoduleid = this.myConfig.modulecode;
        this.headers.ent_id = this.getEnt_id();
        let _session = { 'user_code': this.getUserCode(), 'user_name': this.getUserName() };
        this.headers.session = JSON.stringify(_session);
        let url = '?ent_id=' + this.headers.ent_id +'&billmoduleid=' + this.headers.billmoduleid + '&session='+ this.headers.session;
        this.uploadfile = this.myConfig.uploadfile + encodeURI(url);
        this.customInit ();
        if (!this.myConfig.hide) {
            this.setShowGrid(true);
        }
        this.setTitleStyle();
        if (this.myConfig.notdelfile) {
            this.myConfig.items[0].visible = true;
        } else {
            this.myConfig.items[0].visible = false;
        }
    },
    computed: {
        titleClass () {
            return `efuture-title-font-${this.myConfig.titleType}`;
        },
        headClass () {
            return `efuture-card-head-title-${this.myConfig.titleType}`;
        },
        extraClass () {
            return `efuture-card-extra-title-${this.myConfig.titleType}`;
        }
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        modulecode: {
            type:String,
            default:null
        }
    },
    methods: {
        customInit() {
            if (this.myConfig.hide) {
                this.pStyle = 'cursor:pointer';
                this.iconStyle = 'transform: rotate(90deg)';
            } 
            this.cardPadding = 5 * Number(this.myConfig.titleType);
            this.cardStyle = 'padding-left:'+this.cardPadding+'px;padding-right:'+this.cardPadding+'px;padding-bottom: 10px;';
        },
        toggle () {
            if (this.myConfig.hide) {
                this.showGrid = !this.showGrid;
                this.setTitleStyle();
            }
        },
        setShowGrid(value) {
            this.showGrid = value;
            this.setTitleStyle();
        },
        setTitleStyle () {
            if (this.showGrid) {
                this.iconStyle = 'transform: rotate(90deg)';
                this.cardPadding =  5 * Number(this.myConfig.titleType);
                this.cardStyle = 'padding-left:'+this.cardPadding+'px;padding-right:'+this.cardPadding+'px;padding-bottom: 10px;';
            } else {
                this.iconStyle = '';
                this.cardPadding  = 0;
                this.cardStyle = '';
            }
        },
        actionRender (h, params) {
            let temp = [];
            if (params.row.filekey) {
                temp.push(h('Col',[h('a', {
                    on: {
                        click:() => {
                            this.downFile(params);
                        }
                    }
                },'下载')]));
                if (this.myConfig.readOnly === false || this.showBtn) {
                    if (!this.myConfig.notdelfile) {
                        if (this.btnReadOnly) {
                            temp.push(h('Col',[h('span','删除')]));
                        } else {
                            temp.push(h('Col',[h('a', {
                                on: {
                                    click:() => {
                                        this.delFile(params);
                                    }
                                }
                            },'删除')]));
                        }
                    } else {
                        if (params.row.modflag !== 'M' && params.row.modflag !== 'D' ) {
                            if (this.btnReadOnly) {
                                temp.push(h('Col',[h('span','删除')]));
                            } else {
                                temp.push(h('Col',[h('a', {
                                    on: {
                                        click:() => {
                                            this.delFile(params);
                                        }
                                    }
                                },'删除')]));
                            }
                        }
                    } 
                }
                if (this.isType(params.row.filetype) !== '0') {
                    temp.push(h('Col',[h('a', {
                        on: {
                            click:() => {
                                this.searchFile(params);
                            }
                        }
                    },'查看')]
                ));
                }

                if (this.myConfig.readOnly === false && this.myConfig.notdelfile) {
                    if (params.row.modflag === 'M') {
                        temp.push(h('Col',[h('a', {
                            on: {
                                click:() => {
                                    this.recall(params);
                                }
                            }
                        },'撤回')]));
                    }
                  
                }
            }
            return   h('Row', {
                props:{
                    gutter:16,
                    type:'flex',
                    justify:'start',
                    align:'middle'
                }
            },temp);
        },
        sizeActionRender(h, params) {
            let fize = Number(params.row.filesize);
            let str = '';
            if (fize<1024 ){
                str = fize +'B';
            }
            if (fize > 1024 && fize < 1048576){
                str =parseFloat(fize/1024).toFixed(2) +'K';
            }
            if (fize > 1048576 && fize < 1073741824){
                str =parseFloat(fize/1048576).toFixed(2) +'M';
            }
            if (fize > 1073741824 ){
                str =parseFloat(fize/1073741824).toFixed(2) +'G';
            }
            return  h('span',str);
        },
        downFile(params) {
            let downUrl = this.myConfig.downfile + params.row.filekey + '&session=' + encodeURI(this.getSession()) + "&ent_id=" + this.getEnt_id();
            window.open(downUrl);
        },
        delFile(params) {
            if (!this.checkIsEdit()) {
                return;
            }
            if (!this.myConfig.notdelfile) {
                this.$refs.grid.delRow(params.index);
                let delUrl = this.myConfig.delfile + params.row.filekey + "&ent_id=" + this.getEnt_id();
                if (this.myConfig.delDbFile) {
                    $.ajax({
                        type : 'POST',
                        url : encodeURI(delUrl),
                        async : true,
                        dataType : 'json'
                    });
                }
            } else {
                if (params.row.modflag === 'I') {
                    this.$refs.grid.delRow(params.index);
                }
                if (params.row.modflag === 'N') {
                    let row = this.$Method.copy(params.row);
                    row.modflag = 'M';
                    this.$refs.grid.updateRow(params.index, row);
                }
            }
            if (this.myConfig.readOnly) {
                this.setReadOnly(false);
            }
            if (this.showBtn) {
                let obj = {};
                obj.name = 'editGrid';
                obj.gridname = this.myConfig.name;
                this.$emit('doAction', obj);
            }
        },
        recall(params) {
            let row = this.$Method.copy(params.row);
            row.modflag = 'N';
            this.$refs.grid.updateRow(params.index, row);
        },
        searchFile(params) {
            if (this.isType(params.row.filetype) === '1') {
                this.showTxt(params);
            }
            if (this.isType(params.row.filetype) === '2') {
                this.showPhoto(params);
            }
            if (this.isType(params.row.filetype) === '3') {
                this.showPdf(params);
            }
        },
        handleSuccess (res) {
            let newRow = [];
            if (res.data && res.data.length > 0) {
                res.data.forEach(el => {
                    let row = {};
                    if (el['end_id'] !== undefined) {
                        row['end_id'] = el['end_id'];
                    }
                    row['filekey'] = el['filekey'];
                    row['filename'] = el['filename'];
                    row['filetype'] = el['filetype'];
                    row['modflag'] = el['modflag'];
                    row['ph_timestamp']  = el['ph_timestamp'];
                    row['filesize']  = el['filesize'];
                    row.billmoduleid = el.billmoduleid;
                    row.modflag = 'N';
                    newRow.push(row);
                });
            }
            if (newRow.length > 0) {
                newRow.forEach(el => {
                    this.$refs.grid.addRow(el);
                });
            }
            this.flag = false;
            this.hideLoading();
        },
        handleMaxSize (file) {
            this.alert('文件[' + file.name + ']的文件大小不允许超过' + this.myConfig.fileSize + 'M');
            this.hideLoading();
        },
        isType (filetype) {
            var type = '';
            if (!filetype) {
                filetype = '';
            }
            filetype = filetype.toLowerCase();
            if (filetype === 'log' || filetype === 'xml' || filetype === 'txt') {
                type = '1';
            } else if (filetype === 'bmp' || filetype === 'jpg' || filetype === 'png'
                    || filetype === 'gif' || filetype === 'jpeg' || filetype === 'apng'
                    || filetype === 'svg') {
                type = '2';
            } else if (filetype === 'pdf') {
                type = '3';
            } else {
                type = '0';
            }
            return type;
        },
        setPro (obj) {
            if (obj) {
                this.myConfig = Object.assign({}, this.myConfig, obj);
            }
        },
        setReadOnly(value) {
            let obj = {};
            obj.readOnly = value;
            this.setPro(obj);
            this.$refs.grid.setReadOnly(true);
        },
        showTxt(params) {
            let downUrl = this.myConfig.downfile + params.row.filekey ;
            let htmlObj = $.ajax({
                url : encodeURI(downUrl),
                async : false
            });
            let str = htmlObj.responseText;
            str = str.replace(/\r\n/ig, '<br/>');
            this.textStr =str;
            this.txtPanelFlag = true;
        },
        showPhoto(params) {
            let downUrl = this.myConfig.downfile + params.row.filekey;
            this.imgUrl = downUrl;
            if (this.viewer === undefined) {
                this.viewer = new Viewer(this.$refs.photo, {
                    'url': 'original'
                });
            }
            this.viewer.show();
        },
        showPdf(params) {
            let pdfUrl = this.myConfig.pdffile + params.row.filekey ;
            pdfObject.embed(encodeURI(pdfUrl), this.$refs.pdf);
            this.pdfFlag = true;
        },
        getChangeData() {
            return this.$refs.grid.getChangeData();
        },
        setData(data) {
            this.initData = this.$Method.copy(data);
            this.$refs.grid.setData(data);
        },
        clearData() {
            this.$refs.grid.clearData();
        },
        getData() {
            this.$refs.grid.getData();
        },
        handleBeforeUpload () {
            const check = this.$refs.upload.fileList.length < this.myConfig.fileNum;
            if (!check) {
                this.alert('上传的文件数量过多(一次最多允许上传'+this.myConfig.fileNum+'个文件)');
            }
            if (!this.flag) {
                this.flag = true;
                this.loadingtext = '上传中';
                this.showLoading();
            }
            return check;
        },
        editGrid () {
            if (this.checkIsEdit()) {
                this.$nextTick(() => {
                    this.$refs.upload.clearFiles();
                });
                if (this.myConfig.readOnly) {
                    this.setReadOnly(false);
                }
                document.querySelector('#iviewUp input').click();
                let obj = {};
                obj.name = 'editGrid';
                obj.gridname = this.myConfig.name;
                this.$emit('doAction', obj);
            } 
        },
        cancelGrid() {
            this.$refs.grid.setData(this.$Method.copy(this.initData));
            this.setReadOnly(true);
            let obj = {};
            obj.name = 'cancelGrid';
            obj.gridname = this.myConfig.name;
            this.$emit('doAction', obj);
        },
        isChange() {
            return this.$refs.grid.isChange();
        },
        checkIsEdit() {
            let flag = true;
            if (this.myConfig.editObjectBefore) {
                flag = this.myConfig.editObjectBefore(this.myConfig.name);
            }
            return flag;
        },
        setShowBtn(value) {
            this.showBtn = value;
        },
        setBtnReadOnly(value) {
            this.btnReadOnly = value;
        }

    }
};
</script>



// WEBPACK FOOTER //
// src/components/layouttemplate/appendix.vue